import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import type { QualificationTypeCounts } from './qualification.model';


export interface Employment{
  
  id:string;
  department:string;
  jointCommittee:string;
  contractType:string;
  function:OrganisationProfileFunction|null;
  startDate:Date|null;
  endDate:Date|null;
  costPerHour:string;
  employmentPercentage:number;
  active:boolean;
}

export interface OrganisationProfileFunction{
  id:string;
  name:string;
  certifications:{id:string, name:string}[];
  memberCount:number;
  // Qualification requirements linked to the function, per type (collection payload only).
  qualificationCounts?:QualificationTypeCounts;
  // The same requirements as one number: every type together.
  qualificationCount?:number;
}

@Injectable({
  providedIn: 'root'
})

export class EmploymentAdapter implements Adapter<Employment> {
  adapt(item: any): Employment {
    return {
      id: item.id,
      department:item.department.split('/').pop(),
      jointCommittee:item.jointCommittee.split('/').pop(),
      contractType:item.contractType??'',
      function:item.function??null,
      startDate:item.startDate? new Date(item.startDate): null,
      endDate:item.endDate? new Date(item.endDate): null,
      costPerHour:item.hourlyWage??'',
      employmentPercentage:item.employmentPercentage??'100',
      active: item.activeEmployment

    } as Employment
  }
}
